import CheckboxSelectAll from '@stimulus-components/checkbox-select-all'

export default CheckboxSelectAll
